"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfClockEntryDto = instanceOfClockEntryDto;
exports.ClockEntryDtoFromJSON = ClockEntryDtoFromJSON;
exports.ClockEntryDtoFromJSONTyped = ClockEntryDtoFromJSONTyped;
exports.ClockEntryDtoToJSON = ClockEntryDtoToJSON;
exports.ClockEntryDtoToJSONTyped = ClockEntryDtoToJSONTyped;
/**
 * Check if a given object implements the ClockEntryDto interface.
 */
function instanceOfClockEntryDto(value) {
    if (!('clockInTime' in value) || value['clockInTime'] === undefined)
        return false;
    if (!('clockOutTime' in value) || value['clockOutTime'] === undefined)
        return false;
    if (!('tookMealBreak' in value) || value['tookMealBreak'] === undefined)
        return false;
    return true;
}
function ClockEntryDtoFromJSON(json) {
    return ClockEntryDtoFromJSONTyped(json, false);
}
function ClockEntryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'clockInTime': json['clockInTime'],
        'clockOutTime': json['clockOutTime'],
        'tookMealBreak': json['tookMealBreak'],
    };
}
function ClockEntryDtoToJSON(json) {
    return ClockEntryDtoToJSONTyped(json, false);
}
function ClockEntryDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'clockInTime': value['clockInTime'],
        'clockOutTime': value['clockOutTime'],
        'tookMealBreak': value['tookMealBreak'],
    };
}
//# sourceMappingURL=ClockEntryDto.js.map